<template>
   <div style="background: #FAFAFA;">
      <div class="container" style="padding-bottom: 40px; padding-top: 0.5rem;">
        <div class="top-spot mt-5">
            <h5 @click="goBack()"><span><i class="fa fa-chevron-left"></i></span> Challenges</h5>
        </div>
        <div v-if="loading">
            <PageLoader></PageLoader>
        </div>
        <div class="form-group">
            <div class="row select-search-option">
              <div class="col-md-3">
                <select class="form-control" name="" id="week" v-model="challenge_week">
                  <option value="" slected disabled>Select Week</option>
                  <option style="text-transform: capitalize;" :value="item.id" v-for="item in cohortWeeks" :key="item.id">{{ item.name }}</option>
                </select>
              </div>

              <div class="col-md-3">
                <select class="form-control" name="" id="challenge" v-model="challenge">
                  <option value="" slected disabled>Select Challenge</option>
                  <option :value="item.id" v-for="item in cohortCategories" :key="item.id">{{ item.name }}</option>
                </select>
              </div>

              <div class="col-md-3">
                <select class="form-control" name="" id="age" v-model="ageRange">
                  <option value="" slected disabled>Select Age</option>
                  <option :value="item.id" v-for="item in ageGroups" :key="item.id">{{ item.range }}</option>
                </select>
              </div>

             <div class="col-md-3">
                <select class="form-control" name="" id="age" v-model="cohort">
                  <option value="" slected disabled>Select Cohort</option>
                  <option :value="item.id" v-for="item in actualCohort" :key="item.id">{{ item.name }}</option>
                </select>
             </div>
            </div>
        </div>

        <div v-if="individualLeaders.length == 0 && !loading">
            <EmptyState :emptyData="emptyDataObject"></EmptyState>
        </div>

        <div v-else>
          <div class="ranked">
            <h5>You are ranked {{ kidPosition }} out of {{ individualLeaders.length }}</h5>
          </div>
          <div class="row justify-content-center">
      
            <!-- class="col-md-4 col-4" -->
            <div
              :class="individualLeaders.length === 1 ? 'col-md-4' : 'col-12 col-md'"
              v-for="item in individualLeaders.slice(0, 3)"
              :key="item.id"
            >
              <div class="profile-card text-center p-4">
      
                <div class="badge-wrapper">
      
                  <!-- gear -->
                  <img
                    src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773065440/profile-geer_lw0ii2.svg"
                    class="gear"
                  />
      
                  <!-- avatar -->
                  <img v-if="item.avatar_url  != null"
                    :src="item.avatar_url"
                    class="avatar"
                  />
                  <img v-else
                    src="../../assets/images/user.svg"
                    class="avatar"
                  />
                  <!-- <img
                    :src="item.avatar"
                    class="avatar"
                  /> -->
      
                </div>
      
                <h3 class="mt-3">{{ item.display_name }}</h3>
                <p class="points">{{ item.total_points }} pts</p>
      
              </div>
            </div>
      
          </div>

          <div class="challengers-list-holder">
            <div class="challengers-list" v-for="item in individualLeaders.slice()"
              :key="item.id">
              <div class="list-c">
                <small>{{ item.position }}</small>
                <img v-if="item.avatar_url != null" :src="item.avatar_url" alt="" style="border: 1px solid #e2e3e3;">
                <img v-else src="../../assets/icons/profile-icon.svg" alt="" style="border: 1px solid #e2e3e3;">
                <div>
                  <p>{{ item.display_name }} <span class="span_you d-none d-lg-block" v-if="item.kid_id == kidId">(You)</span></p>
                  <h4 class="you_position d-block d-sm-none" v-if="item.kid_id == kidId">(You)</h4>
                </div>
              </div>

              <h6>{{ item.total_points }} pts</h6>
            </div>
          </div>
        </div>
      </div>
   </div>
  </template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import EmptyState from "../../components/EmptyState.vue";
import moment from "moment";
export default {
  name: "ChallengeLeaderboard",
  components: {
        // Header
        PageLoader,
        EmptyState
    },
  data(){
    return{
      loading: false,
      individualLeaders: [],
      filtersData: "",
      cohortWeeks: [],
      ageGroups: [],
      cohortCategories: [],
      actualCohort: [],
      ageRange: "",
      challenge: "",
      challenge_week: "1",
      cohort: "",
      kidPosition: "",
      kidId: "",
      users:[
        {
          id:1,
          name:"Ubokulom A.",
          points:120,
          avatar:"https://i.pravatar.cc/150?img=1"
        },
        {
          id:2,
          name:"Sophia",
          points:98,
          avatar:"https://i.pravatar.cc/150?img=5"
        },
        {
          id:3,
          name:"David",
          points:150,
          avatar:"https://i.pravatar.cc/150?img=8"
        }
      ],
      emptyDataObject: {
          header: "No Data yet",
          option: "Yet to collate any challenge leaderboard"
      },

    }
  },
  watch: {
    challenge_week(newValue, oldValue) { 
      this.loading = true;
      if (newValue) {
        this.fetchIndividualLeaderBoard();
      }
    },
    challenge(newValue, oldValue) { 
      this.loading = true;
      if (newValue) {
        this.fetchIndividualLeaderBoard();
      }
    },
    ageRange(newValue, oldValue) { 
      this.loading = true;
      if (newValue) {
        this.fetchIndividualLeaderBoard();
      }
    },
    cohort(newValue, oldValue) { 
      this.loading = true;
      if (newValue) {
        this.fetchIndividualLeaderBoard();
      }
    },
  },
  created() {
      const kidItem = JSON.parse(localStorage.getItem('kidDetails'));
      if (kidItem) {
          this.kidId = kidItem.id;
          // console.log("CoachForm", this.coachForm)
      }
  },
  mounted() {
    this.fetchLeaderBoardFilters();
   this.fetchIndividualLeaderBoard();
  },
  methods: {
    goBack() {
      this.$router.back();
    }, 
    fetchLeaderBoardFilters() {
      this.loading = true;
        Api.getRequest(`fetch-parameters-for-leader-board`).then(res => {
            // console.log("Posting list", res);
            this.loading = false;
            // console.log("Filteers", res);
            if(res.data.success) {
              this.filtersData = res.data.data;
              this.cohortWeeks = res.data.cohort_weeks;
              this.ageGroups = res.data.age_groups;
              this.cohortCategories = res.data.categories;
              this.actualCohort = res.data.cohorts;
            }
            if (res.data.error) {
                return this.$store.commit("setApiFailed", res.data.error);
            }
        }).catch(err => {
            console.log("err:", err);
            this.loading = false;
        })
    },
    fetchIndividualLeaderBoard() {
        this.loading = true;
        // "fetch-kid-leader-board" Old Api
        Api.getRequest(`robust-kid-leader-board?kid_id=${this.kidId}&week_id=${this.challenge_week}&age_group_id=${this.ageRange}&category_id=${this.challenge}&cohort_id=${this.cohort}`).then(res => {
            this.loading = false;
            // console.log("Individual Leader board", res);
            if(res.data.success) {
              this.individualLeaders = res.data.data;
              this.kidPosition = res.data.kid_position;
            }
            if (res.data.error) {
                return this.$store.commit("setApiFailed", res.data.error);
            }
        }).catch(err => {
            console.log("err:", err);
            this.loading = false;
        })
    },
  },
 

}
</script>

<style scoped lang="scss">
.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
}
.select-search-option {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // gap: 15px;
  margin-top: 20px;
  margin-bottom: 30px;
  overflow: scroll;
  select {
    border: 0.5px solid #D8D8D8;
    background: #ffffff;
    border-radius: 50px;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    color: #1C2B3A;
    box-shadow: none !important;
    outline: 0 !important;
    min-width: 150px;
    width: 100%;
    margin-bottom: 10px;
  }

}
.ranked {
  padding: 8px 18px;
  border-radius: 50px;
  height: 46px;
  background: #2AB3E6;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin: auto;
  margin-bottom: 30px;
  h5 {
    font-family: Lato;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    color: #1C2B3A;
    text-align: center;
    margin-bottom: 0;
  }

}
.profile-card {
  /* height: 411px; */
  height: 100%; /* allow responsive height inside column */
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 15px;
  /* background: linear-gradient(
    to bottom,
    #c7dde6,
    #b9d3de,
    #cfd7db
  ); */

      /* background: linear-gradient(180deg, #BCE5F4 19.82%, rgba(250, 250, 250, 0) 100%); */
    /* background: linear-gradient(180deg, rgba(250, 250, 250, 0.7) 0%, #BCE5F4 20%, rgba(250, 250, 250, 0) 100%); */
    /* background: linear-gradient(180deg, rgba(250, 250, 250, 0.9) 0%, #BCE5F4 25%, #BCE5F4 75%, rgba(250, 250, 250, 0.3) 100%); */
    background: linear-gradient(180deg, rgba(250, 250, 250, 0) 0%, /* top fades from white */ #BCE5F4 50%, /* middle solid blue */ rgba(250, 250, 250, 0) 100% /* bottom fades to white */);

  border-radius:10px;
}

.profile-card h3 {
  font-family: Nunito;
  font-weight: 700;
  font-size: 28px;
  line-height: 24px;
  color: #4B4B4F;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  // white-space: nowrap;
}

.profile-card p {
  font-family: Nunito;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #4B4B4F;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  // white-space: nowrap;
}

.badge-wrapper{

  /* position:relative;

  width:150px;
  height:150px;

  margin:auto; */

  position: relative;
  width: 65%;   /* responsive width inside column */
  padding-top: 65%; /* keeps it square */
  margin: auto;
}

.gear{

  position:absolute;

  width:100%;
  height:100%;

  top:0;
  left:0;

  z-index:1;
  
}

.avatar{

  /* position:absolute;

  width:110px;
  height:110px;

  border-radius:50%;

  object-fit:cover;

  top:50%;
  left:50%;

  transform:translate(-50%,-50%);

  z-index:2; */

  position: absolute;
  width: 80%;  /* slightly smaller than gear */
  height: 80%;
  border-radius: 50%;
  object-fit: cover;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.points{
  font-size:20px;
  color:#555;
}

.row > .col-md-4:nth-child(2) .profile-card {
  margin-top: 60px !important;
}
.row > .col-md-4:nth-child(3) .profile-card {
  margin-top: 120px !important;
}

.list-c {
  display: flex;
  align-items: center;
  gap: 15px;
}
.challengers-list {
  border-bottom: 1px solid #F5F7FA;
  padding: 20px 12px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 42px;
    height: 42px;
    border-radius: 50px;
    object-fit: cover;
  }
  small {
    font-family: Nunito;
    font-weight: 700;
    font-size: 20px;
    color: #5D6F7C;

  }
  p {
    font-family: Nunito;
    font-weight: 700;
    font-size: 24px;
    line-height: 22px;
    color: #5D6F7C;
    text-align: left;
    margin-bottom: 0;
    display: flex;
    // padding-left: 10;
  }
  h6 {
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #5D6F7C;
    text-align: right;

  }
}

.you_position {
  color: #2AB3E6 !important;
  font-size: 13px !important;
  // display: flex !important;
  text-align: left;
}
.span_you {
  color: #2AB3E6 !important;
  font-size: 13px !important;
  margin-left: 7px;
}

.challengers-list-holder {
  margin-top: 10rem;
  border: 1px solid #F5F7FA;
  background: #ffffff;
  border-radius: 10px;
  // padding: 20px 5px;
}
@media (max-width: 575.98px) {

  .profile-card {
    padding: 20px 4px !important;
  }
  .badge-wrapper{
    width:100%;
    padding-top:95%;
  }

  .row > .col-md-4:nth-child(2) .profile-card {
    margin-top: 30px !important;
  }

  .row > .col-md-4:nth-child(3) .profile-card {
    margin-top: 60px !important;
  }

  /* .avatar{
  width:90%;
  height:90%;
  } 
  
  */

  .profile-card h3 {
    font-size: 16px;
  }
  .profile-card p {
    font-size: 14px;
  }
  .challengers-list-holder {
    margin-top: 5rem;
  }
  .challengers-list {
    p {
      font-size: 14px;
    }
  }
}
</style>